"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBadge = void 0;
var react_1 = __importDefault(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("./styles/status-badge.scss");
var STATUS_META = {
    placeholder: {
        label: 'Planned',
        tooltip: 'Planned section — no UI or backend implementation yet.',
        modifier: 'ws-status-badge--placeholder',
    },
    'ui-only': {
        label: 'UI only',
        tooltip: 'Interface available, but backend logic is not yet wired up — data shown may be mocked.',
        modifier: 'ws-status-badge--ui-only',
    },
    'half-ready': {
        label: 'Half ready',
        tooltip: 'Partially implemented — UI is in place and some backend wiring is live, but the experience is not yet complete.',
        modifier: 'ws-status-badge--half-ready',
    },
    ready: {
        label: 'Ready',
        tooltip: 'Ready for integration — UI and backend wiring are in place.',
        modifier: 'ws-status-badge--ready',
    },
};
/**
 * Small status chip used to flag the implementation state of a feature
 * (e.g. on admin tabs, popup headers, page sections). Visual styling is
 * driven by the `status` prop; copy can be overridden via `label` /
 * `tooltip`.
 */
exports.StatusBadge = function (_a) {
    var status = _a.status, label = _a.label, tooltip = _a.tooltip, className = _a.className;
    var meta = STATUS_META[status];
    var classes = ['ws-status-badge', meta.modifier];
    if (className) {
        classes.push(className);
    }
    return (react_1.default.createElement(office_ui_fabric_react_1.TooltipHost, { content: tooltip !== null && tooltip !== void 0 ? tooltip : meta.tooltip },
        react_1.default.createElement("span", { className: classes.join(' ') }, label !== null && label !== void 0 ? label : meta.label)));
};
